module.exports = __webpack_public_path__ + "static/media/Fichier 22.52a43d5d.svg";